import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'

import CsvStudentLevelUploadContainer from '@frontrow/console/src/components/pages/students-page/csv-student-level-upload'
import {StudentDelete} from '@frontrow/console/src/components/pages/students-page/student-delete'

export default function StudentsPageContainer(): React.ReactElement {
  return (
    <React.Fragment>
      <H1>Students</H1>
      <StudentDelete />
      <CsvStudentLevelUploadContainer />
    </React.Fragment>
  )
}
